import { Container, Table, Row, Col } from 'react-bootstrap';

const BidIncrementsPage = () => {
    // Data untuk tabel kelipatan penawaran
        const incrementsData = [
        {from: 'Rp 100.000', to: 'Rp 500.000', increment: 'Rp 20.000' },
        {from: 'Rp 500.000', to: 'Rp 1000.000', increment: 'Rp 50.000' },
        {from: 'Rp 1.000.000', to: 'Rp 5.000.000', increment: 'Rp 100.000' },
        {from: 'Rp 5.000.000', to: 'Rp 10.000.000', increment: 'Rp 250.000' },
        {from: 'Rp 10.000.000', to: 'Rp 20.000.000', increment: 'Rp 500.000' },
        {from: 'Rp 20.000.000', to: 'Rp 100.000.000', increment: 'Rp 1.000.000' },
        {from: 'Rp 100.000.000', to: 'Rp. 1.000.000.000', increment: 'Rp 5.000.000' },
        {from: 'Rp 1.000.000.000', to: 'Ke Atas', increment: 'Rp 10.000.000' },
        ];
    
    return (
        <div className="py-5" style={{ backgroundColor: '#f0efe9' }}>
            <Container>
                <div className="text-center mb-5">
                    <h1 className="display-4" style={{ fontFamily: 'Cinzel, serif' }}>Kelipatan Penawaran</h1>
                    <p className="lead" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        Juru lelang akan mengikuti kelipatan penawaran standar yang tercantum di bawah ini.
                    </p>
                </div>

                <Row className="justify-content-center">
                    <Col md={10} lg={8}>
                        <p style={{ fontFamily: 'Poppins, sans-serif', textAlign: 'center' }}>
                            Kelipatan penawaran adalah jumlah minimum yang harus Anda tambahkan ke harga saat ini untuk membuat penawaran baru. Juru lelang memiliki keleluasaan untuk mengubah kelipatan ini kapan saja selama lelang berlangsung.
                        </p>
                        <Table striped bordered hover responsive className="mt-4 shadow-sm">
                            <thead className="table-dark">
                                <tr>
                                    <th>Harga Saat Ini</th>
                                    <th>Kelipatan Berikutnya</th>
                                </tr>
                            </thead>
                            <tbody>
                                {incrementsData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.from} - {item.to}</td>
                                        <td>{item.increment}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default BidIncrementsPage;
